// vue-code/src/config/vueconfig.js
//
// Runtime contract: window.configEnv is a JSON string. The .NET VueController
// serializes ConfigManager.GetEnv() into ViewData["configEnv"], which
// Index.cshtml renders as <script>window.configEnv = '...'</script> before this
// module loads. For local dev (npm run serve), vue-code/public/index.html
// hardcodes a JSON string with the same (Vue-side) key names.
//
// GetEnv() outputs keys that match bzbsconfig.{env}.js property names
// (bzbsUrl, client_id, liffId, ...), so Object.assign merges runtime overrides
// directly onto the selected static config.

import { config } from '@/config/bzbsconfig.js';
import { config as configDev } from '@/config/bzbsconfig.dev.js';
import { config as configStg } from '@/config/bzbsconfig.stg.js';
import { config as configPrd } from '@/config/bzbsconfig.prd.js';

import { campaignConfig, dashboardConfig, categoryConfig, historyConfig, couponConfig } from './configlist.js';

export default function () {
    // 1) Parse runtime config injected from .NET (or local dev override)
    let configEnvObj = {};
    try {
        configEnvObj = JSON.parse(window.configEnv || '{}');
    } catch (e) {
        console.warn('[vueconfig] failed to parse window.configEnv:', e);
    }

    // 2) Pick the static config based on runtime build
    let appConfig = null;
    switch (configEnvObj.build) {
        case 'dev':
            appConfig = configDev;
            break;
        case 'stg':
            appConfig = configStg;
            break;
        case 'prd':
            appConfig = configPrd;
            break;
        default:
            appConfig = config;
            break;
    }

    // 3) Merge runtime config from .NET over the static config.
    //    Keys align with bzbsconfig keys, so assign directly.
    appConfig = Object.assign(appConfig, configEnvObj);

    // 4) Attach static config-list exports
    appConfig.campaignConfig = campaignConfig;
    appConfig.dashboardConfig = dashboardConfig;
    appConfig.categoryConfig = categoryConfig;
    appConfig.historyConfig = historyConfig;
    appConfig.couponConfig = couponConfig;

    appConfig.setting = {
        cache: 'session',
        addressType: 'profile', // profile, addressList
        encryptAccount: 'none', // none, token, all
    };

    return appConfig;
}
